import { atom } from 'jotai';

export const checkLogInterviewer = atom<boolean>(false);
